var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.4C0 6.4471 6.4471 0 14.4 0H21.6C29.5529 0 36 6.4471 36 14.4V21.6C36 29.5529 29.5529 36 21.6 36H14.4C6.4471 36 0 29.5529 0 21.6V14.4Z",
    fill: "#F0F1EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2089_2158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5L19.275 12.225C18.8628 12.6456 18.6318 13.2111 18.6318 13.8C18.6318 14.3889 18.8628 14.9544 19.275 15.375L20.625 16.725C21.0456 17.1373 21.6111 17.3682 22.2 17.3682C22.789 17.3682 23.3544 17.1373 23.775 16.725L25.5 15",
    stroke: "#9CA37F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 20.2496L11.475 11.4746C11.1757 11.7679 10.9379 12.118 10.7755 12.5043C10.6132 12.8907 10.5295 13.3055 10.5295 13.7246C10.5295 14.1437 10.6132 14.5585 10.7755 14.9449C10.9379 15.3312 11.1757 15.6813 11.475 15.9746L16.95 21.4496C17.475 21.9746 18.45 21.9746 19.05 21.4496L20.25 20.2496ZM20.25 20.2496L25.5 25.4996",
    stroke: "#9CA37F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.575 25.35L15.375 20.625",
    stroke: "#9CA37F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 12.75L18 18",
    stroke: "#9CA37F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2089_2158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntake);
export default __webpack_public_path__ + "static/media/intake.cf02349c0c4661f8a0e5990f64ec1198.svg";
export { ForwardRef as ReactComponent };